import { render, staticRenderFns } from "./TerminalImpressao.vue?vue&type=template&id=750260d4&scoped=true&"
import script from "./TerminalImpressao.vue?vue&type=script&setup=true&lang=js&"
export * from "./TerminalImpressao.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "750260d4",
  null
  
)

export default component.exports